import React from 'react'
import classNames from 'classnames'

import { StateProvider, getHTML, getRichText } from '../../core'
import Content from '../../content'

import './collection.scss'

class Item extends React.Component {
  state = {
    isActive: false,
  }

  render() {
    const { item, context } = this.props

    return (
      <div 
        styleName="item" 
        data-is-active={this.state.isActive}
      >
        <Content 
          typename={item.__typename} 
          id={item.id} 
          context={context}
        />
      </div>
    )
  }
}

class CollectionSection extends React.Component {
  render() {
    const data = this.props.data || {}
    const context = this.props.context || {}

    const { 
      editableContent,
      items,
      columns,
      theme,
      alignment,
    } = data


    const allItems = items || []
    const itemsByTag = allItems.reduce((obj, item) => {
      const firstTag = item.tags && item.tags[0]
      if (firstTag) {
        const clean = firstTag.trim()
        obj[clean] = obj[clean] || []
        obj[clean].push(item)
      }
      return obj
    }, {})

    const itemsClass = classNames(
      "items",
      columns && `columns-${columns}`,
      alignment && `align-${alignment}`,
    )

    const sectionClass = classNames(
      "collection-section",
      theme && `theme-${theme}`,
    )

    return (
      <section styleName={`${sectionClass}`}>
        {editableContent && <div styleName='editable-content'>{getRichText(editableContent)}</div>}
        
        <StateProvider value={0}>{(tag, setTag) => (
          <StateProvider value={1}>{(page, setPage) => {
            const tags = Object.keys(itemsByTag)
            const tagItems = tags.length > 0
              ? itemsByTag[tags[tag]]
              : allItems

            let itemsToShow = tagItems.slice()
            let itemsLeft = []

            if (columns) {
              const itemsPerPage = columns * 5
              itemsToShow = tagItems.slice().splice(0, page * itemsPerPage)
              itemsLeft = tagItems.length - itemsToShow.length
            }

            return (
              <div styleName='items-wrapper'>
                {tags.length > 0 && (
                  <div styleName='tags-wrapper'>
                    {tags.map((t, i) => (
                      <div
                        styleName="tag"
                        key={i} 
                        data-is-active={i === tag}
                        onClick={() => setTag(i)}
                      >{t}</div>
                    ))}
                  </div>
                )}

                <div styleName={`${itemsClass}`}>
                  {itemsToShow.map((item, i) => {
                    if (!item) {
                      return null
                    }
              
                    return (
                      <Item item={item} context={context} key={i} />
                    )
                  })}
                </div>

                {columns && itemsLeft > 0 
                  && <button onClick={() => setPage(page + 1)}>Show More</button>
                }
              </div>
            )
          }}</StateProvider>
        )}</StateProvider>
      </section>
    )
  }
}

export default CollectionSection